(() => {
  const config = document.querySelector('script[data-ts-finder]');
  if (!config) return;
  const messages = config.dataset;
  const records = new WeakMap();
  let nextId = 0;

  function describe(element, id) {
    const ids = (element.getAttribute('aria-describedby') || '').split(/\s+/).filter(value => value && !value.startsWith('ts-ymm-help-'));
    ids.push(id);
    const value = ids.join(' ');
    if (element.getAttribute('aria-describedby') !== value) element.setAttribute('aria-describedby', value);
  }

  function refresh(root) {
    const record = records.get(root);
    const form = root.querySelector('form');
    const button = form && form.querySelector('[id="ymm_search"]');
    if (!record || !form || !button) return;
    let help = form.querySelector('.ts-ymm-help');
    if (!help) {
      help = document.createElement('p');
      help.className = 'ts-ymm-help';
      help.setAttribute('role', 'status');
      help.setAttribute('aria-live', 'polite');
      help.setAttribute('aria-atomic', 'true');
      form.appendChild(help);
    }
    help.id = record.id;
    const fields = Array.from(form.querySelectorAll('select.ymm-filter'));
    // The app keeps a second, hidden finder on some pages. Match its control visibility.
    const hidden = !fields.some(field => field.getClientRects().length && getComputedStyle(field).visibility !== 'hidden');
    if (help.hidden !== hidden) help.hidden = hidden;
    const selected = field => field && field.value && field.value !== '-1';
    const loading = Boolean(form.querySelector('[id="ymm_loader"]'));
    let message = messages.selectAll;
    if (loading) message = messages.loading;
    else if (!button.disabled) message = messages.ready;
    else if (selected(fields[0]) && selected(fields[1])) message = messages.selectModel;
    else if (selected(fields[0])) message = messages.selectMakeModel;
    if (help.textContent !== message) help.textContent = message;
    form.setAttribute('aria-busy', String(loading));
    describe(button, record.id);
    fields.forEach(field => describe(field, record.id));
  }

  function queue(root) {
    const record = records.get(root);
    if (!record || record.pending) return;
    record.pending = true;
    queueMicrotask(() => {
      record.pending = false;
      if (root.isConnected) refresh(root);
    });
  }

  function install(root) {
    if (records.has(root)) return;
    const record = { id: 'ts-ymm-help-' + (++nextId), pending: false };
    records.set(root, record);
    const observer = new MutationObserver(() => queue(root));
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'style', 'class', 'hidden'] });
    root.addEventListener('change', () => queue(root));
    refresh(root);
  }

  function start() {
    document.querySelectorAll('[id="ymm_searchbox"]').forEach(install);
    window.addEventListener('resize', () => document.querySelectorAll('[id="ymm_searchbox"]').forEach(queue));
    new MutationObserver(mutations => {
      mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches('[id="ymm_searchbox"]')) install(node);
        node.querySelectorAll('[id="ymm_searchbox"]').forEach(install);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
